import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export const useImages = (mydayId: number) => {
  return useQuery({
    queryKey: ['useImages', mydayId],
    queryFn: () =>
      mydayId
        ? axios
            .get(`${envApiUrl}/files/images`, {
              headers: {
                'Content-Type': 'application/json',
                'content-type': 'multipart/form-data',
                mydayid: mydayId,
              },
              withCredentials: true,
              xsrfCookieName: 'csrftoken',
              xsrfHeaderName: 'x-csrf-token',
            })
            .then((response) => {
              return response.data;
            })
        : { data: [] },
  });
};
